/*  eslint-disable no-use-before-define, no-restricted-syntax, guard-for-in */
import _isEmpty from 'lodash-es/isEmpty';
import _isNull from 'lodash-es/isNull';
import _isNil from 'lodash-es/isNil';
import _isObject from 'lodash-es/isObject';
import isFinite from 'lodash-es/isFinite';
import _isUndefined from 'lodash-es/isUndefined';

export const isNumber = isFinite;
export const isObject = _isObject;
export const isNull = _isNull;

export function isAbsent(value) {
  return _isNil(value) || Number.isNaN(value);
}

const BLANK_REGEX = /^\s*$/;
export function isBlank(value) {
  return isAbsent(value) || (typeof value === 'string' && BLANK_REGEX.test(value));
}

export function isDefined(value) {
  return !_isUndefined(value);
}

export function isEmpty(value) {
  if (!isObject(value)) {
    return isAbsent(value) || value === '';
  }

  return _isEmpty(value);
}

export function isPresent(value) {
  return isDefined(value) && !isNull(value) && !Number.isNaN(value);
}
